import { fetchConToken } from '../helpers/fetch';

export const loadHomeSummary = async ({ currencyId, signal }) => {
    const params = new URLSearchParams();
    if (currencyId) params.set('id_moneda', currencyId);
    const response = await fetchConToken(`dashboard/home?${params}`, undefined, 'GET', { signal });
    if (!response.headers.get('content-type')?.includes('application/json')) {
        throw new Error('El resumen no está disponible en el servidor. Verifica que el backend esté actualizado y vuelve a intentar.');
    }
    const body = await response.json();
    if (!response.ok || !body.ok || !body.data?.sections) {
        throw new Error(body.msg || 'No se pudo cargar el resumen de tu negocio.');
    }
    return body.data;
};
